var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getFormattedDataABACRefreshResponse = function (_a) {
    var fullResponse = _a.fullResponse, initialValues = _a.initialValues;
    return fullResponse.reduce(function (acc, _a, index) {
        var _b, _c;
        var error = _a.error, data = _a.data;
        if (error || !data || !data.data) {
            return acc;
        }
        var _d = initialValues[index], scope = _d.scope, featureKey = _d.featureKey;
        return __assign(__assign({}, acc), (_b = {}, _b[scope] = __assign(__assign({}, acc[scope]), (_c = {}, _c[featureKey] = data.data, _c)), _b));
    }, {});
};
